import { themeOptionFactory as mobile } from "./mobile"
import { themeOptionFactory as kioskV } from "./kiosk-v"
import { themeOptionFactory as kioskH } from "./kiosk-h"

export const themeOptionFactories = {
  mobile,
  "kiosk-v": kioskV,
  "kiosk-h": kioskH,
}
